import { z } from 'zod';
import { uuidV7Schema } from './ids';

export const handoffPolicySchema = z.strictObject({
  initialAssigneeId: uuidV7Schema,
  escalationAssigneeId: uuidV7Schema,
  responseMinutes: z.number().int().min(1).max(10_080),
});
export type HandoffPolicy = z.infer<typeof handoffPolicySchema>;

export const handoffAlertSchema = z.object({
  id: uuidV7Schema,
  conversationId: uuidV7Schema,
  dueAt: z.string(),
  createdAt: z.string(),
});
